import { render } from "./AIAssistant.vue?vue&type=template&id=1a047c36&scoped=true"
import script from "./AIAssistant.vue?vue&type=script&lang=js"
export * from "./AIAssistant.vue?vue&type=script&lang=js"

import "./AIAssistant.vue?vue&type=style&index=0&id=1a047c36&scoped=true&lang=css"
import "./AIAssistant.vue?vue&type=style&index=1&id=1a047c36&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a047c36"]])

export default __exports__